import React, {useEffect, useState} from 'react';
import AnnunciService from '../../services/AnnunciService';
import Button from '../../components/Button/Button';
import Spinner from '../../components/spinner/Spinner';
import Autocomplete from '../../components/Autocomplete/Autocomplete';
import CheckBox from '../../components/checkBox/CheckBox';
import Input from '../../components/inputText/Input';
import Formatter from '../../utils/Formatter';

const LABEL_MAP = {
    autosufficiente: 'Autosufficiente',
    parzialmenteAutosufficiente: 'Parz. autosufficiente',
    carrozzina: 'In carrozzina',
    allettata: 'Allettata',
    disabilita: 'Disabilità mentale',
    assistenzaDiurna: 'Assistenza diurna',
    assistenzaNotturna: 'Assistenza notturna',
    assistenzaFineSettimana: 'Fine settimana',
    assistenzaChiamata: 'Assistenza ad ore',
    h24: 'H24',
    alloggio: 'Con alloggio',
    vitto: 'Con vitto',
    automunito: 'Automunito/a'
}

const filtriIniziali = {
    comune: null, sessoAssistito: null,
    autosufficiente: false, parzialmenteAutosufficiente: false,
    carrozzina: false, allettata: false, disabilita: false,
    assistenzaDiurna: false, assistenzaNotturna: false,
    assistenzaFineSettimana: false, assistenzaChiamata: false,
    h24: false, alloggio: false, vitto: false, automunito: false
}

function AnnunciLista({conContatto}) {
    const [annunci, setAnnunci] = useState([])
    const [totalPages, setTotalPages] = useState(0)
    const [page, setPage] = useState(0)
    const [showSpinner, setShowSpinner] = useState(false)
    const [filtri, setFiltri] = useState(filtriIniziali)
    const [cercaId, setCercaId] = useState("")
    const [dettaglio, setDettaglio] = useState(null)
    const [rerenderAutocomplete, setRerenderAutocomplete] = useState(0)
    const comuni = JSON.parse(sessionStorage.getItem("comuni") || "[]")
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice") || "{}")

    useEffect(() => { caricaAnnunci(0) }, [])

    function caricaAnnunci(p) {
        setShowSpinner(true)
        const paramsGrezzi = {
            page: p, size: 10, paginazione: true,
            ...filtri,
            ...(cercaId ? {id: cercaId} : {})
        }
        const params = Object.fromEntries(
            Object.entries(paramsGrezzi).filter(([, v]) => v !== null && v !== false && v !== "")
        )
        const promise = conContatto
            ? AnnunciService.getAllAnnunciConContatto(params)
            : AnnunciService.getAllAnnunci(params)
        promise
            .then(resp => {
                setAnnunci(resp.data?.content || [])
                setTotalPages(resp.data?.totalPages || 0)
                setPage(p)
            })
            .catch(err => console.error(err))
            .finally(() => setShowSpinner(false))
    }

    function onFiltroChange(id, value) {
        setFiltri(prev => ({...prev, [id]: value}))
    }

    function onApplicaFiltri() { caricaAnnunci(0) }

    function onReset() {
        setFiltri(filtriIniziali)
        setCercaId("")
        setRerenderAutocomplete(prev => prev + 1)
        setShowSpinner(true)
        const params = {page: 0, size: 10, paginazione: true}
        const promise = conContatto
            ? AnnunciService.getAllAnnunciConContatto(params)
            : AnnunciService.getAllAnnunci(params)
        promise
            .then(resp => {
                setAnnunci(resp.data?.content || [])
                setTotalPages(resp.data?.totalPages || 0)
                setPage(0)
            })
            .catch(err => console.error(err))
            .finally(() => setShowSpinner(false))
    }

    const sectionHeaderStyle = {
        display: "block",
        padding: "7px 0",
        color: "#333",
        fontSize: "14px",
        fontWeight: "normal",
        textDecoration: "none",
        cursor: "pointer",
        borderBottom: "1px solid #dee2e6"
    }

    const arrowSvg = (
        <svg width={"18"} height={"18"} fill={"#1b7ea9"} viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg" style={{marginRight: "6px", verticalAlign: "middle"}}>
            <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
            <path fill="none" d="M0 0h24v24H0z"/>
        </svg>
    )

    return (
        <div className={"pt-4"} style={{marginLeft: "30px", marginRight: "30px"}}>
            <Spinner showSpinner={showSpinner}/>
            <div style={{marginBottom: "20px"}}>
                <h1 className={"h5"} style={{fontWeight: "bold"}}>Annunci</h1>
            </div>

            <div className={"row"}>
                {/* SIDEBAR FILTRI */}
                <div className={"col-md-3"} style={{
                    border: "1px solid #dee2e6",
                    padding: "15px",
                    backgroundColor: "#fafafa",
                    minWidth: "260px"
                }}>

                    <div style={{marginBottom: "12px"}}>
                        <label style={{fontWeight: "bold", display: "block", marginBottom: "4px", fontSize: "14px"}}>Comune</label>
                        <Autocomplete id={"comuneFiltro"}
                            ariaLabel={"Comune"}
                            placeholder={"Cerca comune..."}
                            value={filtri.comune ? comuniPerCodice[filtri.comune] : null}
                            suggestions={comuni}
                            rerender={rerenderAutocomplete}
                            onChange={(id, val) => onFiltroChange("comune", val?.codice || null)}/>
                    </div>

                    <div style={{marginBottom: "12px"}}>
                        <label style={{fontWeight: "bold", display: "block", marginBottom: "4px", fontSize: "14px"}}>Codice annuncio</label>
                        <Input id={"cercaId"} ariaLabel={"Codice annuncio"} placeholder={"N. annuncio"}
                            value={cercaId}
                            onChange={(e) => setCercaId(e.target.value.replace(/\D/g, ""))}/>
                    </div>

                    <div style={{display: "flex", gap: "8px", marginBottom: "16px"}}>
                        <Button typeButton={"Blue"} text={"Applica"} onClick={onApplicaFiltri}
                            style={{height: "40px", width: "100px", fontSize: "14px"}}/>
                        <Button typeButton={"White"} text={"Reset"} onClick={onReset}
                            style={{height: "40px", width: "80px", fontSize: "14px"}}/>
                    </div>

                    {/* Sesso assistito */}
                    <div style={{marginBottom: "4px"}}>
                        <a href={"#collapseSesso"} data-toggle={"collapse"} aria-expanded={"true"}
                           aria-controls={"collapseSesso"} style={sectionHeaderStyle}>
                            {arrowSvg}Sesso assistito
                        </a>
                        <div className={"collapse show"} id={"collapseSesso"} style={{paddingLeft: "8px", paddingTop: "6px"}}>
                            <CheckBox id={"sessoAssistitoM"} text={"Uomo"}
                                checked={filtri.sessoAssistito === "M"}
                                onChange={(e) => onFiltroChange("sessoAssistito", e.target.checked ? "M" : null)}/>
                            <CheckBox id={"sessoAssistitoF"} text={"Donna"}
                                checked={filtri.sessoAssistito === "F"}
                                onChange={(e) => onFiltroChange("sessoAssistito", e.target.checked ? "F" : null)}/>
                        </div>
                    </div>

                    {/* Condizioni assistito */}
                    <div style={{marginBottom: "4px", marginTop: "8px"}}>
                        <a href={"#collapseCondizioni"} data-toggle={"collapse"} aria-expanded={"true"}
                           aria-controls={"collapseCondizioni"} style={sectionHeaderStyle}>
                            {arrowSvg}Condizioni assistito
                        </a>
                        <div className={"collapse show"} id={"collapseCondizioni"} style={{paddingLeft: "8px", paddingTop: "6px"}}>
                            {['autosufficiente','parzialmenteAutosufficiente','carrozzina','allettata','disabilita'].map(f => (
                                <CheckBox key={f} id={f} text={LABEL_MAP[f]}
                                    checked={!!filtri[f]}
                                    onChange={(e) => onFiltroChange(f, e.target.checked)}/>
                            ))}
                        </div>
                    </div>

                    {/* Disponibilità assistente */}
                    <div style={{marginTop: "8px"}}>
                        <a href={"#collapseDisp"} data-toggle={"collapse"} aria-expanded={"true"}
                           aria-controls={"collapseDisp"} style={sectionHeaderStyle}>
                            {arrowSvg}Disponibilità assistente
                        </a>
                        <div className={"collapse show"} id={"collapseDisp"} style={{paddingLeft: "8px", paddingTop: "6px"}}>
                            {['assistenzaDiurna','assistenzaNotturna','assistenzaFineSettimana','assistenzaChiamata','h24','alloggio','vitto','automunito'].map(f => (
                                <CheckBox key={f} id={f} text={LABEL_MAP[f]}
                                    checked={!!filtri[f]}
                                    onChange={(e) => onFiltroChange(f, e.target.checked)}/>
                            ))}
                        </div>
                    </div>
                </div>

                {/* TABELLA */}
                <div className={"col"} style={{overflowX: "auto", paddingLeft: "20px"}}>
                    <table className={"table table-hover"}>
                        <thead>
                            <tr>
                                <th>N.</th><th>Data</th><th>Comune</th>
                                <th>Assistito</th><th>Assistente</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {annunci.map(a => (
                                <tr key={a.id}>
                                    <td>{a.id}</td>
                                    <td>{a.dataCreazione ? new Date(a.dataCreazione).toLocaleDateString('it-IT') : ""}</td>
                                    <td>{comuniPerCodice[a.comune]?.descrizione || a.comune}</td>
                                    <td>{Formatter.formatAssistito(a)}</td>
                                    <td>{Formatter.formatAssistente(a)}</td>
                                    <td>
                                        <button type="button"
                                            style={{border: "none", background: "none", color: "#1b7ea9", cursor: "pointer", fontWeight: "bold", padding: "0", fontSize: "14px"}}
                                            onClick={() => setDettaglio(a)}>Dettagli</button>
                                    </td>
                                </tr>
                            ))}
                            {annunci.length === 0 && (
                                <tr><td colSpan={6} style={{color: "#666", fontStyle: "italic"}}>Nessun annuncio trovato</td></tr>
                            )}
                        </tbody>
                    </table>

                    <div style={{marginTop: "10px"}}>
                        {Array.from({length: totalPages}, (_, i) => (
                            <Button key={i} typeButton={i === page ? "Blue" : "White"} text={String(i + 1)}
                                onClick={() => caricaAnnunci(i)}
                                style={{height: "35px", width: "40px", fontSize: "14px", marginRight: "4px"}}/>
                        ))}
                    </div>
                </div>
            </div>

            {/* MODALE DETTAGLIO */}
            {dettaglio && (
                <div className={"modal show d-block"} style={{backgroundColor: "rgba(0,0,0,0.5)"}}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header"}>
                                <h5 style={{color: "#1b7ea9", fontWeight: "bold", marginBottom: 0}}>Annuncio #{dettaglio.id}</h5>
                                <button type="button" className={"close"} onClick={() => setDettaglio(null)}
                                    style={{background: "none", border: "none", fontSize: "20px", cursor: "pointer"}}>&times;</button>
                            </div>
                            <div className={"modal-body"}>
                                <h6 style={{fontWeight: "bold", color: "#1b7ea9"}}>Assistito</h6>
                                <p style={{marginBottom: "4px"}}><strong>Sesso:</strong> {dettaglio.sessoAssistito === "M" ? "Uomo" : dettaglio.sessoAssistito === "F" ? "Donna" : "-"}</p>
                                <p style={{marginBottom: "4px"}}><strong>Comune:</strong> {comuniPerCodice[dettaglio.comune]?.descrizione || dettaglio.comune || "-"}</p>
                                <p style={{marginBottom: "4px"}}><strong>Condizioni:</strong> {Formatter.formatAssistito(dettaglio) || "-"}</p>
                                {dettaglio.note && <p style={{marginBottom: "4px"}}><strong>Note:</strong> {dettaglio.note}</p>}
                                <hr/>
                                <h6 style={{fontWeight: "bold", color: "#1b7ea9"}}>Assistente ricercato</h6>
                                <p style={{marginBottom: "4px"}}><strong>Sesso:</strong> {dettaglio.sessoAssistente === "M" ? "Uomo" : dettaglio.sessoAssistente === "F" ? "Donna" : "-"}</p>
                                <p style={{marginBottom: "4px"}}><strong>Disponibilità:</strong> {Formatter.formatAssistente(dettaglio) || "-"}</p>
                                {conContatto && (
                                    <>
                                        <hr/>
                                        <h6 style={{fontWeight: "bold", color: "#1b7ea9"}}>Contatti</h6>
                                        {dettaglio.telefono && <p style={{marginBottom: "4px"}}><strong>Tel:</strong> {dettaglio.telefono}</p>}
                                        {dettaglio.cellulare && <p style={{marginBottom: "4px"}}><strong>Cell:</strong> {dettaglio.cellulare}</p>}
                                        {dettaglio.email && <p style={{marginBottom: "4px"}}><strong>Email:</strong> {dettaglio.email}</p>}
                                    </>
                                )}
                                {!conContatto && (
                                    <p style={{marginTop: "10px"}}><em>Per ulteriori informazioni rivolgersi allo sportello comunale più vicino</em></p>
                                )}
                            </div>
                            <div className={"modal-footer"}>
                                <Button typeButton={"Blue"} text={"Chiudi"} onClick={() => setDettaglio(null)}
                                    style={{height: "40px", width: "100px"}}/>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AnnunciLista
